<template>
  <div class="shimmer-table-rows">
    <div
      v-for="n in rows"
      :key="n"
      class="shimmer-table-rows__row"
    >
      <span
        v-for="(w, i) in widths"
        :key="i"
        class="shimmer"
        :style="{ width: w }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShimmerTableRows',
  props: {
    rows: {
      type: Number,
      default: 6,
    },
    columns: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    widths() {
      // Vary bar widths a little so rows don't look perfectly uniform.
      const pattern = ['22%', '16%', '14%', '20%', '12%', '10%']
      return Array.from({ length: this.columns }, (_, i) => pattern[i % pattern.length])
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes shimmer-sweep {
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}

.shimmer {
  display: inline-block;
  height: 12px;
  background: linear-gradient(90deg, #eef0f4 25%, #f7f8fb 37%, #eef0f4 63%);
  background-size: 400px 100%;
  animation: shimmer-sweep 1.4s ease-in-out infinite;
  border-radius: 6px;
}

.shimmer-table-rows {
  padding: 0.5rem 0.25rem;
}

.shimmer-table-rows__row {
  display: flex;
  align-items: center;
  gap: 1.75rem;
  padding: 0.65rem 0.5rem;

  &:not(:last-child) {
    border-bottom: 1px solid #f4f4f8;
  }
}
</style>
